'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import classNames from 'classnames';

const ContentViewport = ({
  wrapperClassName,
  paddingClassName,
  wrapperStyle,
  children
}) => /*#__PURE__*/_jsx("div", {
  className: classNames(paddingClassName, 'content-viewport__responsive-padding'),
  children: /*#__PURE__*/_jsx("div", {
    className: classNames(wrapperClassName, 'content-viewport__responsive-wrapper'),
    style: wrapperStyle,
    children: children
  })
});

ContentViewport.propTypes = {
  children: PropTypes.node,
  paddingClassName: PropTypes.string,
  wrapperClassName: PropTypes.string,
  wrapperStyle: PropTypes.object
};
ContentViewport.defaultProps = {
  children: '',
  paddingClassName: '',
  wrapperClassName: '',
  wrapperStyle: {}
};
export default ContentViewport;